var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"pull-right push-10-l",attrs:{"size":"xs","tooltip":"Edit","icon":"pencil","color":"warning"},on:{"click":function($event){return _vm.$emit("click")}}})}
var staticRenderFns = []

export { render, staticRenderFns }